import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'todayIcon'
})
export class TodayIconPipe implements PipeTransform {

  transform(value: string): boolean {
    
    let result = false;
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0');
    let yyyy = today.getFullYear();

    let strToday = mm + '/' + dd + '/' + yyyy;

    return result = strToday.localeCompare(value) ? false: true;
    
  }

}
